import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClearService } from './clear.service';

@Component({
  selector: 'app-clear',
  templateUrl: './clear.component.html',
  styleUrls: ['./clear.component.scss']
})
export class ClearComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();

  @ViewChild('clear', { static: true })
  clear;

  modal;

  fn;

  message: string;

  constructor(private modalService: NgbModal, private clearService: ClearService) { }

  ngOnInit(): void {
    this.clearService.toggle()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this.fn = value.operate;
        this.message = value.msg;
        this.open();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  open() {
    this.modal = this.modalService.open(this.clear, { ariaLabelledBy: 'modal-basic-title' });
    this.modal.result.then((result) => {
    }, (reason) => {
      this.close();
    });
  }

  confirm() {
    this.fn();
    this.close();
  }

  cancel() {
    this.close();
  };

  close() {
    this.modal.close();
    this.message = '';
  }

}
